import React, { Component } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { Divider, message, Input, DatePicker } from "antd";
import moment from "moment";
import { _uuid } from "../../utils/dataUtil";
import { getSaturday } from "../../utils/dateUtil";
import { req_add_pim_staff_overtime_weekend } from "../../api";
import PicturesWall from "./pictures-wall";
import "./pictures-wall.css";
class WeekOvertimeApplyModal extends Component {
  // 基礎通用參數 //////////////////////////////////////////////
  static propTypes = {
    data: PropTypes.object.isRequired,
    ip: PropTypes.string.isRequired,
  };
  state = {
    lock: false,
    reason: "",
    weekday: getSaturday(),
    starttime: "0800",
    endtime: "1700",
    row: {
      Uid: "",
      ClockType: "OVERTIME",
      StaffCode: this.props.user.userCode,
      OvertimeDate: "",
      OvertimekStart: "0800",
      OvertimeEnd: "1700",
      OvertimeReason: "休息日加班",
      ApplyStatus: "APPLY",
      OvertimeStatus: "WORK",
      RecordCreatorCode: this.props.user.userCode,
      RecordDescription: "",
      ReasonFileUrl: "",
    },
  };

  constructor(props) {
    super(props);
    this.get_overtime_images = React.createRef();
  }

  api_add_item_week_overtime = async (item) => {
    const { token } = this.props.user;
    const result = await req_add_pim_staff_overtime_weekend(item, token);
    return result.status;
  };

  convertDateTime = (string_date, string_time) => {
    const year = string_date.substring(0, 4);
    const month = string_date.substring(4, 6);
    const day = string_date.substring(6, 8);
    const hours = string_time.substring(0, 2);
    const minutes = string_time.substring(2, 4);

    return `${year}-${month}-${day} ${hours}:${minutes}`;
  };

  // 操作互動處理 //////////////////////////////////////////////
  handle_btn_event = (tag, item) => {
    const { reason, weekday, starttime, endtime, row } = this.state;
    switch (tag) {
      case "OverTimeWeekendApply":
        if (reason.length === 0) {
          message.error("請輸入休息日加班原因");
          return;
        }
        if (weekday !== "" && this.checkWeekend(weekday)) {
          console.log("是周六");
          if (this.checkTime(starttime, endtime)) {
            row.Uid = _uuid();
            row.OvertimeDate = weekday;
            row.OvertimeStart = starttime;
            row.OvertimeEnd = endtime;
            row.RecordDescription = reason;
            console.log(row);

            const reasonFile = this.get_overtime_images.current.output_files();
            if (typeof reasonFile[0] === "undefined") {
              message.error("尚未上傳加班佐證資料");
            } else {
              if (reasonFile[0].indexOf("rc-upload") !== -1) {
                message.error("加班資料驗證失敗，請重傳");
              } else {
                row.ReasonFileUrl = reasonFile[0];
                //console.log(row); //row
                this.setState({ lock: true });
                this.api_add_item_week_overtime(row).then((result) => {
                  if (result === "success") {
                    message.success("申請加班成功");
                    this.setState({ lock: true });
                  } else {
                    this.setState({ lock: false });
                    message.error("申請加班失敗");
                  }
                });
              }
            }
          }
        } else {
          message.error("請輸入正確休假日日期");
        }

        break;
      default:
    }
  };

  checkWeekend = (dateString) => {
    // 將輸入的字符串轉換為日期物件
    const date = new Date(
      dateString.slice(0, 4),
      parseInt(dateString.slice(4, 6)) - 1,
      dateString.slice(6, 8)
    );

    // 檢查日期是否為周六
    const day = date.getDay();
    if (day === 6) {
      //day === 0 ||
      this.setState({ weekday: dateString });
      return true;
    } else {
      console.log("不是週六");
      this.setState({ weekday: "" });
      return false;
    }
  };

  checkTime = (starttime, endtime) => {
    // 檢查輸入是否為四位數字
    if (!this.validateInput(starttime) || !this.validateInput(endtime)) {
      message.error("請輸入四位數字的時間格式，例如0800");
      return false;
    }

    // 將輸入轉換為時間格式
    const startTime = parseInt(starttime.slice(0, 2));
    const startMinute = parseInt(starttime.slice(2, 4));
    const endTime = parseInt(endtime.slice(0, 2));
    const endMinute = parseInt(endtime.slice(2, 4));

    // 檢查時間是否有效
    if (
      !this.isValidTime(startTime, startMinute) ||
      !this.isValidTime(endTime, endMinute)
    ) {
      alert("時間格式錯誤，請確保時間在00:00至23:59之間");
      return false;
    }

    // 檢查起始時間是否早於結束時間
    if (
      !this.isStartTimeBeforeEndTime(startTime, startMinute, endTime, endMinute)
    ) {
      alert("起始時間不能晚於結束時間");
      return false;
    }
    return true;
  };

  validateInput = (input) => {
    return /^\d{4}$/.test(input);
  };

  // 驗證時間是否有效
  isValidTime = (hour, minute) => {
    return hour >= 0 && hour <= 23 && minute >= 0 && minute <= 59;
  };

  // 檢查起始時間是否早於結束時間
  isStartTimeBeforeEndTime = (startHour, startMinute, endHour, endMinute) => {
    if (startHour < endHour) return true;
    if (startHour === endHour && startMinute < endMinute) return true;
    return false;
  };

  onDateChange = (date, dateString) => {
    this.setState({ weekday: dateString });
  };

  disabledDate = (current) => {
    // moment().day()：0=週日, 1=週一, ..., 6=週六
    const day = current.day();
    return day !== 0 && day !== 6; // 只允許週六(6)和週日(0)
  };

  ////////
  render() {
    const dateFormat = "YYYYMMDD";
    const ReasonFileUrl = [];
    const fileUrlPath = "/api/UploadFile/AddInsideMediaFile";
    const { data } = this.props;
    const { weekday, starttime, endtime, reason, lock } = this.state;
    //console.log(data);
    return (
      <>
        <Divider orientation="left" style={{ borderColor: "#7cb305" }} plain>
          <i className="fas fa-file-medical"></i> 休息日欲請加班
        </Divider>
        <DatePicker
          onChange={this.onDateChange}
          format={dateFormat}
          placeholder="請輸入休息日日期"
          style={{ width: "100%" }}
          value={weekday ? moment(weekday, dateFormat) : null}
          disabledDate={this.disabledDate}
        />
        {/* <Input
          placeholder="請輸入休息日日期"
          value={weekday}
          onChange={(e) => this.setState({ weekday: e.target.value })}
        ></Input> */}
        <Input
          placeholder="請輸入起始時間"
          value={starttime}
          onChange={(e) => this.setState({ starttime: e.target.value })}
        ></Input>
        <Input
          placeholder="請輸入結束時間"
          value={endtime}
          onChange={(e) => this.setState({ endtime: e.target.value })}
        ></Input>
        <Input
          placeholder="請輸入休息日加班原由"
          value={reason}
          onChange={(e) => this.setState({ reason: e.target.value })}
        ></Input>
        <PicturesWall
          ref={this.get_overtime_images}
          images_source={ReasonFileUrl}
          api_url={fileUrlPath}
          self_filename="原由佐證圖檔"
        ></PicturesWall>
        <button
          className="btn btn-info btn-sm"
          style={{ width: "100%" }}
          onClick={() => this.handle_btn_event("OverTimeWeekendApply", data)}
          disabled={lock}
        >
          <i class="fas fa-user-clock" style={{ marginRight: "5px" }}></i>{" "}
          申請休息日加班
        </button>
      </>
    );
  }
}

export default connect(
  (state) => ({ user: state.user }),
  {}
)(WeekOvertimeApplyModal);
